// extracted by mini-css-extract-plugin
module.exports = {"root":"Hint_root__Q-9xD","header":"Hint_header__c8MWI","body":"Hint_body__1l1MN","close":"Hint_close__3OuJG"};